<template>
	<div class="user-item" :class="{'active': selected}">

		<template v-if="user.profile_pic">
			<img class="profile" :src="user.profile_pic" alt="" @error="imgError(this)">
		</template>
		<template v-else>
			<img class="profile" src="/static/img/assets/livechat/profile.png" alt="">
		</template>
		

		<span>{{ user.first_name + ' ' + user.last_name | truncate(23)}} <span class="notification" v-if="hasNewMessage"></span></span>

		<p class="timestamp small">{{ user.lastreply_time | time }}</p>
	</div>
</template>

<script>
import moment from "moment"
	export default {
		props : ['value','selected'],
		data : function() {
			return {
				user: this.value,
				hasNewMessage: false
			}
		},
		filters: {
			time : function(date) {
	            if (typeof date === 'string') {
	                date = moment(date);
	            }
	            return date.format('h:mm A')
	        }
		},
		mounted: function() {
		},
		methods: {
			imgError: function(event,el){
				// console.log('not load')
				this.value.profile_pic = '/static/img/assets/livechat/profile.png'
			}
		},
		watch: {
			value: function(newVal, oldVal){
				this.user = this.value
				if (newVal.lastreply_time != oldVal.lastreply_time) {
					if (this.selected != true) {
						this.hasNewMessage = true
					}
				}
			},
			selected: function(newVal, oldVal){
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item.vue